import order from '../en/order'

const cnOrder = {}

for (const cn in order) {
  cnOrder[cn] = cn
}

export default cnOrder
